module.exports = __webpack_public_path__ + "static/media/issuers.2330e65d.csv";